import styled from 'styled-components'
import { colors } from '../../../lib/colors'
interface Text_Props {
  fadeIn?: boolean
}
export const TextWrapper = styled.div<Text_Props>`
  text-align: center;
  font-size: 12px;
  color: ${colors.quaternary};
  text-transform: uppercase;
  transform: translateX(-100%);
  opacity: 0;
  animation: ${({ fadeIn }) =>
    fadeIn ? 'fadein 0.3s forwards' : `fadeout 0.3s forwards`};
  span {
    margin-left: 5px;
    color: ${colors.secondary};
  }

  @keyframes fadein {
    0% {
      transform: translateX(-100%);
      animation-timing-function: cubic-bezier(0.08, 0, 0, 1);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes fadeout {
    0% {
      transform: translateX(0);
      animation-timing-function: cubic-bezier(0.08, 0, 0, 1);
      opacity: 1;
    }
    100% {
      transform: translateX(100%);
      opacity: 0;
    }
  }
`
